export const frontmatter = {
    "draft": false,
    "title": "Guía: Campañas",
    "description": "Cómo crear y enviar campañas en OnnIA: datos generales, plantillas, destinatarios, programación y estados del ciclo de vida.",
    "sidebar_label": "Campañas",
    "sidebar_group": "referencia",
    "sidebar_order": 5
}

export const toc = [
    {
        "depth": 2,
        "id": "acceso-al-modulo",
        "value": "Acceso al módulo"
    },
    {
        "depth": 2,
        "id": "crear-una-campana",
        "value": "Crear una campaña"
    },
    {
        "depth": 3,
        "id": "paso-1-datos-generales",
        "value": "Paso 1: Datos generales"
    },
    {
        "depth": 3,
        "id": "paso-2-plantillas-y-canales",
        "value": "Paso 2: Plantillas y canales"
    },
    {
        "depth": 3,
        "id": "paso-3-destinatarios-y-programacion",
        "value": "Paso 3: Destinatarios y programación"
    },
    {
        "depth": 2,
        "id": "estados-de-la-campana",
        "value": "Estados de la campaña"
    },
    {
        "depth": 2,
        "id": "acciones-disponibles",
        "value": "Acciones disponibles"
    },
    {
        "depth": 2,
        "id": "recomendaciones",
        "value": "Recomendaciones"
    }
]